import { render, staticRenderFns } from "./ColorSetting.vue?vue&type=template&id=783351ae&scoped=true"
import script from "./ColorSetting.vue?vue&type=script&lang=js"
export * from "./ColorSetting.vue?vue&type=script&lang=js"
import style0 from "./ColorSetting.vue?vue&type=style&index=0&id=783351ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783351ae",
  null
  
)

export default component.exports